/* ==========================================================================
   The Painted Wolves — Floof Engine
   Starfield + shooting stars + seasonal drifting characters.
   No dependencies. ~7KB unminified. Respects prefers-reduced-motion.
   Pauses entirely when the tab is hidden.

   Characters are DATA, not code. Edit PW_SEASONS below, or override from
   Liquid with  window.PW_FLOOF_CONFIG = {...}  before this script loads.
   Each character may be an emoji string OR { src: "cdn-url.svg", w: 54 }
   so hand-drawn Kittl artwork can replace emoji later with no code change.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- seasonal character sets ---------- */
  var PW_SEASONS = {
    halloween: {
      from: '09-15', to: '11-01',
      cast: ['👻', '🦇', '🎃', '🕷️', '🌙'],
      confetti: ['#E8763D', '#6B2233', '#17161A', '#F2B544']
    },
    thanksgiving: {
      from: '11-02', to: '11-30',
      cast: ['🦃', '🍂', '🌽', '🥧'],
      confetti: ['#B85C24', '#F2B544', '#7A4A22', '#FBF8F3']
    },
    christmas: {
      from: '12-01', to: '12-27',
      cast: ['🎅', '🦌', '❄️', '🎁', '⛄'],
      confetti: ['#1F5C46', '#A8322D', '#F2B544', '#FBF8F3']
    },
    newyear: {
      from: '12-28', to: '01-07',
      cast: ['🎇', '✨', '🥂', '🎊'],
      confetti: ['#F2B544', '#2B3A67', '#FBF8F3', '#C4436F']
    },
    valentine: {
      from: '01-25', to: '02-15',
      cast: ['💘', '🌹', '💌', '🧸'],
      confetti: ['#A8322D', '#D9628B', '#F2B544', '#FBF8F3']
    },
    spring: {
      from: '03-01', to: '05-15',
      cast: ['🌷', '🐝', '🦋', '🌱'],
      confetti: ['#7A9E7E', '#F2B544', '#C4436F', '#FBF8F3']
    },
    patriotic: {
      from: '06-20', to: '07-08',
      cast: ['🎆', '⭐', '🦅', '🎈'],
      confetti: ['#2B3A67', '#A8322D', '#FBF8F3', '#F2B544']
    },
    summer: {
      from: '07-09', to: '09-14',
      cast: ['🌊', '☀️', '🦀', '🍦'],
      confetti: ['#2E8FA8', '#F2B544', '#7A9E7E', '#FBF8F3']
    },
    house: {
      cast: ['👽', '🛸', '✦', '🌙'],
      confetti: ['#2B3A67', '#F2B544', '#FBF8F3', '#17161A']
    }
  };

  var CFG = Object.assign({
    seasonOverride: null,     // 'halloween' | 'christmas' | ... | 'house'
    driftEvery: 19000,        // ms between drifting characters
    shootingEvery: 8000,      // ms between shooting star attempts
    starCount: 150,
    enableDrifters: true,
    enableStars: true
  }, window.PW_FLOOF_CONFIG || {});

  /* ---------- work out the season ---------- */
  function currentSeason() {
    if (CFG.seasonOverride && PW_SEASONS[CFG.seasonOverride]) return CFG.seasonOverride;
    var d = new Date();
    var md = String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    for (var k in PW_SEASONS) {
      var s = PW_SEASONS[k];
      if (!s.from) continue;
      // ranges that wrap the new year, e.g. 12-28 -> 01-07
      if (s.from > s.to) { if (md >= s.from || md <= s.to) return k; }
      else if (md >= s.from && md <= s.to) return k;
    }
    return 'house';
  }

  var SEASON = currentSeason();
  var CAST = PW_SEASONS[SEASON].cast;
  var CONFETTI = PW_SEASONS[SEASON].confetti;

  /* expose for other scripts / the theme editor */
  window.PWFloof = { season: SEASON, seasons: PW_SEASONS };

  /* ---------- shared overlay stage ---------- */
  var stage;
  function getStage() {
    if (stage) return stage;
    stage = document.createElement('div');
    stage.className = 'pw-floof-stage';
    stage.setAttribute('aria-hidden', 'true');
    document.body.appendChild(stage);
    return stage;
  }

  /* ---------- 1. starfield with shooting stars ---------- */
  function starfield(canvas) {
    var ctx = canvas.getContext('2d');
    var w, h, stars = [], shooters = [], dpr = Math.min(window.devicePixelRatio || 1, 2);

    function size() {
      var r = canvas.getBoundingClientRect();
      if (!r.width) return;
      w = canvas.width = Math.round(r.width * dpr);
      h = canvas.height = Math.round(r.height * dpr);
      var n = Math.round(CFG.starCount * (r.width / 1400));
      stars = [];
      for (var i = 0; i < n; i++) {
        var layer = Math.random();          // 0 = far, 1 = near
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: (0.3 + layer * 1.4) * dpr,
          sp: (0.015 + layer * 0.13) * dpr,
          o: 0.18 + layer * 0.6,
          t: Math.random() * 6.283,
          tw: 0.008 + Math.random() * 0.02
        });
      }
    }

    function spawnShooter() {
      if (!w || shooters.length > 1) return;
      shooters.push({
        x: (0.25 + Math.random() * 0.65) * w,
        y: Math.random() * h * 0.55,
        len: (70 + Math.random() * 90) * dpr,
        sp: (5.5 + Math.random() * 3.5) * dpr,
        life: 1,
        ang: 0.32 + Math.random() * 0.18
      });
    }

    function frame() {
      requestAnimationFrame(frame);
      if (document.hidden || REDUCE || !w) return;
      ctx.clearRect(0, 0, w, h);

      // stars
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x -= s.sp; s.t += s.tw;
        if (s.x < -3) { s.x = w + 3; s.y = Math.random() * h; }
        ctx.globalAlpha = s.o * (0.55 + 0.45 * Math.sin(s.t));
        ctx.fillStyle = '#FBF8F3';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.2832); ctx.fill();
      }

      // shooting stars
      for (var j = shooters.length - 1; j >= 0; j--) {
        var sh = shooters[j];
        var dx = Math.cos(sh.ang) * sh.sp, dy = Math.sin(sh.ang) * sh.sp;
        sh.x -= dx; sh.y += dy; sh.life -= 0.011;
        if (sh.life <= 0 || sh.x < -sh.len || sh.y > h + sh.len) { shooters.splice(j, 1); continue; }
        var tx = sh.x + Math.cos(sh.ang) * sh.len, ty = sh.y - Math.sin(sh.ang) * sh.len;
        var g = ctx.createLinearGradient(sh.x, sh.y, tx, ty);
        g.addColorStop(0, 'rgba(251,248,243,' + (0.95 * sh.life).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(251,248,243,0)');
        ctx.globalAlpha = 1; ctx.strokeStyle = g;
        ctx.lineWidth = 1.9 * dpr; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(sh.x, sh.y); ctx.lineTo(tx, ty); ctx.stroke();
        ctx.globalAlpha = sh.life; ctx.fillStyle = '#FBF8F3';
        ctx.beginPath(); ctx.arc(sh.x, sh.y, 1.7 * dpr, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    size();
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(size, 180); });
    frame();
    if (!REDUCE) {
      setInterval(function () {
        if (!document.hidden && Math.random() > 0.42) spawnShooter();
      }, CFG.shootingEvery);
      setTimeout(spawnShooter, 2600);
    }
  }

  /* ---------- 2. drifting seasonal characters ---------- */
  function makeChar(entry) {
    if (typeof entry === 'string') {
      var span = document.createElement('span');
      span.textContent = entry;
      return span;
    }
    var img = document.createElement('img');
    img.src = entry.src; img.alt = '';
    img.width = entry.w || 48;
    return img;
  }

  /* Pull a real product off whatever grid is on the page. No theme data
     needed, no extra request — the cards are already in the DOM.        */
  function randomProduct() {
    var cards = document.querySelectorAll('.card-wrapper');
    if (!cards.length) return null;
    var card = cards[Math.floor(Math.random() * cards.length)];
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('.card__media img, img');
    if (!link || !img) return null;
    return {
      href: link.getAttribute('href'),
      src: img.currentSrc || img.src,
      title: (card.querySelector('.card__heading') || {}).textContent || ''
    };
  }

  function drift() {
    if (REDUCE || document.hidden || !CFG.enableDrifters) return;
    var el = document.createElement('div');
    el.className = 'pw-drifter';
    el.appendChild(makeChar(CAST[Math.floor(Math.random() * CAST.length)]));

    /* Roughly a third of the time the creature tows a real product on a
       line. The cargo is clickable and goes straight to that product. */
    var prod = Math.random() < 0.34 ? randomProduct() : null;
    if (prod) {
      var tow = document.createElement('a');
      tow.className = 'pw-drifter__tow';
      tow.href = prod.href;
      tow.setAttribute('aria-label', 'View ' + prod.title.trim());
      tow.innerHTML = '<span class="pw-drifter__line"></span>';
      var cargo = document.createElement('img');
      cargo.src = prod.src; cargo.alt = '';
      tow.appendChild(cargo);
      el.appendChild(tow);
      el.classList.add('pw-drifter--towing');
    }
    el.style.top = (10 + Math.random() * 62) + 'vh';
    el.style.fontSize = (30 + Math.random() * 22) + 'px';
    var dur = 13 + Math.random() * 7;
    el.style.animationDuration = dur + 's';
    // half of them bob as they cross
    if (Math.random() > 0.5) el.classList.add('pw-drifter--bob');
    getStage().appendChild(el);
    setTimeout(function () { el.remove(); }, (dur + 1) * 1000);
  }

  /* ---------- 3. add-to-cart star burst ---------- */
  var STAR_GLYPHS = ['✦', '✧', '✵', '✯', '★'];

  function burst(originEl) {
    if (REDUCE) return;
    var st = getStage();
    var cx = 50, cy = 40;
    if (originEl && originEl.getBoundingClientRect) {
      var r = originEl.getBoundingClientRect();
      cx = ((r.left + r.width / 2) / window.innerWidth) * 100;
      cy = ((r.top + r.height / 2) / window.innerHeight) * 100;
    }
    for (var i = 0; i < 30; i++) {
      var st_ = document.createElement('i');
      st_.className = 'pw-star';
      st_.textContent = STAR_GLYPHS[i % STAR_GLYPHS.length];
      st_.style.color = CONFETTI[i % CONFETTI.length];
      st_.style.left = cx + 'vw';
      st_.style.top = cy + 'vh';
      st_.style.fontSize = (9 + Math.random() * 15) + 'px';
      /* each star gets its own vector out from the button */
      var ang = (Math.PI * 2 * i) / 30 + (Math.random() - 0.5) * 0.5;
      var dist = 90 + Math.random() * 190;
      st_.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      st_.style.setProperty('--dy', (Math.sin(ang) * dist - 40) + 'px');
      st_.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
      st_.style.animationDuration = (0.75 + Math.random() * 0.65) + 's';
      st_.style.animationDelay = (Math.random() * 0.1) + 's';
      st.appendChild(st_);
      (function (n) { setTimeout(function () { n.remove(); }, 1800); })(st_);
    }
  }

  /* ---------- 4. corner heckler ---------- */
  var heckler, heckTimer, heckCount = 0, heckLast = 0;
  var HECK_MAX = 4;          // per session, so it stays funny and not naggy
  var HECK_GAP = 45000;      // never twice within 45s

  function heckle(lines) {
    lines = lines || window.PW_HECKLE_LINES || [];
    if (!lines.length || REDUCE) return;
    var now = performance.now();
    if (heckCount >= HECK_MAX || now - heckLast < HECK_GAP) return;
    heckCount++; heckLast = now;
    if (!heckler) {
      heckler = document.createElement('div');
      heckler.className = 'pw-heckler';
      heckler.innerHTML = '<span class="pw-heckler__guy"></span><span class="pw-heckler__bubble"></span>';
      document.body.appendChild(heckler);
      heckler.addEventListener('click', function () { heckler.classList.remove('is-up'); });
    }
    heckler.querySelector('.pw-heckler__guy').textContent = CAST[Math.floor(Math.random() * CAST.length)];
    heckler.querySelector('.pw-heckler__bubble').textContent = lines[Math.floor(Math.random() * lines.length)];
    heckler.classList.add('is-up');
    clearTimeout(heckTimer);
    heckTimer = setTimeout(function () { heckler.classList.remove('is-up'); }, 7000);
  }

  /* Browse-time triggers. The exit-intent one still exists below, but most
     of these fire while the person is actually looking around, which is
     where the joke lands. Each is throttled by HECK_GAP.                */
  function wireHeckleTriggers() {
    if (REDUCE) return;
    var lines = window.PW_HECKLE_LINES || [];
    if (!lines.length) return;

    /* a) dwelling on the page */
    setTimeout(function () { heckle(lines); }, 24000 + Math.random() * 12000);

    /* b) scrolled deep — they are clearly browsing */
    var deepFired = false;
    window.addEventListener('scroll', function () {
      if (deepFired) return;
      var pct = window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight);
      if (pct > 0.55) { deepFired = true; heckle(lines); }
    }, { passive: true });

    /* c) gone idle mid-page, mouse stopped moving */
    var idle;
    document.addEventListener('mousemove', function () {
      clearTimeout(idle);
      idle = setTimeout(function () { heckle(lines); }, 30000);
    }, { passive: true });

    /* d) came back to the tab */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) setTimeout(function () { heckle(lines); }, 1200);
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    /* The footer is night-coloured but has no canvas of its own, so the
       page opens and closes on the same sky. */
    var footer = document.querySelector('.footer, footer.footer');
    if (footer && CFG.enableStars && !footer.querySelector('[data-pw-stars]')) {
      var fc = document.createElement('canvas');
      fc.setAttribute('data-pw-stars', '');
      fc.setAttribute('aria-hidden', 'true');
      footer.insertBefore(fc, footer.firstChild);
    }
    if (CFG.enableStars) {
      document.querySelectorAll('[data-pw-stars]').forEach(starfield);
    }
    if (CFG.enableDrifters && !REDUCE) {
      setTimeout(drift, 2400);
      setInterval(function () { if (!document.hidden) drift(); }, CFG.driftEvery);
    }
    // confetti on any add-to-cart
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.getAttribute('data-type') === 'add-to-cart-form') {
        burst(e.target.querySelector('[name="add"]'));
      }
    }, true);

    /* browse-time hecklers */
    wireHeckleTriggers();

    /* exit intent, desktop only */
    var lines = (window.PW_HECKLE_LINES || []);
    if (lines.length && window.innerWidth > 900) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 12) heckle(lines);
      });
    }
  }

  window.PWFloof.drift = drift;
  window.PWFloof.burst = burst;
  window.PWFloof.heckle = heckle;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
